import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import "./progressBar.css";
import pt1 from "../../images/pt1.svg";
import pt2 from "../../images/pt2.svg";
import pt3 from "../../images/pt3.svg";
import pt4 from "../../images/pt4.svg";

function BankProgressBar({ score, progressStatusNow }) {
  return (
    <div className="progress-wrapper">
      <ProgressBar
        className="progress"
        percent={progressStatusNow}
        fillBackground="linear-gradient(to right, #edf67e, #fefc0a)"
      >
        
        {score === 0 ? (
          <Step transition="scale">
            {({ accomplished }) => (
              <img
                style={{ filter: `grayscale(${accomplished ? 80 : 80}%)` }}
               
                src={pt1}
                alt="bank icon"
                className="pg-icons progress-bar-icon"
              />
            )}
          </Step>
        ) : (
          <Step transition="scale">
            {({ accomplished }) => (
              <img
                style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                src={pt1}
                alt="bank icon"
                className="pg-icons progress-bar-icon-1"
              />
            )}
          </Step>
        )}

        <Step transition="scale">
          {({ accomplished }) => (
            <img
              style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
    
              src={pt2}
              alt="bank icon"
              className="pg-icons progress-bar-icon-2"
            />
          )}
        </Step>
        <Step transition="scale">
          {({ accomplished }) => (
            <img
              style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
    
              src={pt3}
              alt="bank icon"
              className="pg-icons progress-bar-icon-3"
            />
          )}
        </Step>
        <Step transition="scale">
            {({ accomplished }) => (
              <img
                style={{ filter: `grayscale(${accomplished ? 80 : 80}%)` }}
                src={pt4}
                alt="bank icon"
                className="progress-bar-icon-4"
              />
            )}
          </Step>
      </ProgressBar>
    </div>
  );
}

export default BankProgressBar;
